/** @typedef {Object} singleSearchService
 * @property {Function} search
 */

(function (angular) {
  "use strict";

  angular
    .module("alk.singlesearch")
    /** @name alk.singlesearch.config
     * @ngdoc constant
     * @description Provides for single search configuration
     * @memberof alk.singlesearch
     */
    .constant("alk.singlesearch.config", {})
    .service("singleSearchService", ["alk.singlesearch.config", "$q", "$http", "_", "$rootScope",

      /** @name singleSearchService
       * @ngdoc service
       * @param {service} config [Single Search Configuration object](alk.singlesearch.config.html)
       * @param {service} $q angularJS [promises/deferred objects service](https://docs.angularjs.org/api/ng/service/$q)
       * @param {service} $http angularJS [HTTP communication service](https://docs.angularjs.org/api/ng/service/$http)
       * @param {service} _ [Lodash](https://lodash.com/docs/4.17.4)
       * @param {service} angularJS [root scope](https://docs.angularjs.org/api/ng/service/$rootScope) service
       * @description Provides geocoding and reverse geocoding functions through ALK's [Single Search](http://singlesearch-test-aws-qa.alk.com/) geocoder
       * @returns singleSearchService
       * @memberof alk.singlesearch
       */
      function (config, $q, $http, _, $rootScope) {
        var searchRequests = [];
        //Debounce so that fast typing doesn't spam server with too many requests
        var debouncedSearchHelper = _.debounce(searchHelper, 500, {
          leading: true
        });

        let lazyInitdValidPoiCategories;

        return {
          search: search, // a debounced function with callback
          singleSearchQueryPromise: singleSearchQueryPromise, // a simple promise that can be used for promise chaining
          getValidPoiCategories: getValidPoiCategories
        };

        ////////////

        /**
         * Initiate a single search service request. Will only initiate request if searchParams.query has more than 2 characters.
         * @param {Object} searchParams The same params that the single search API uses. However, do not specify authToken here, it will be handled by this service.
         * @param {Function} searchStartCallback A function that gets invoked before a search network request will be made
         * @param {Function} successCallback A function that gets invoked after a search network request succeeded; first parameter will contain list of search results
         * @param {Function} errorCallback A function that gets invoked after a search network request failed; first parameter will contain error string
         * @memberof singleSearchService
         */
        function search(searchParams, searchStartCallback, successCallback, errorCallback) {
          if (searchParams.query.length <= 2) {
            return;
          }
          debouncedSearchHelper(searchParams, searchStartCallback, successCallback, errorCallback);
        }

        function searchHelper(searchParams, searchStartCallback, successCallback, errorCallback) {
          searchStartCallback();
          clearRequests();
          var request = singleSearchQuery(searchParams, successCallback, errorCallback);
          searchRequests.push(request);
        }

        function clearRequests() {
          for (var i = searchRequests.length - 1; i > -1; i--) {
            searchRequests[i].cancel("new search");
            searchRequests.splice(i, 1);
          }
        }
        
        function setRegion(url, region) {
          if (region === "NA") {
            url = url.replace(/ww|EU/gi, "NA")
          }
          if (region === "EU") {
            url = url.replace(/ww|NA/gi, "EU")
          }
          return url;
        }

        function singleSearchQuery(searchParams, successCallback, errorCallback) {
          angular.extend(searchParams, {
            authToken: config.authToken
          });
          var canceller = $q.defer();
          var cancel = function (reason) {
            canceller.resolve(reason);
            //console.log("Request cancelled");
          };

          config.url = setRegion(config.url, $rootScope.userInfo.region);
          var requestConfig = {};

          if (searchParams.customPlacesToken) {
            requestConfig.headers = {
              Authorization : "token=" + searchParams.customPlacesToken
            };
            delete searchParams.customPlacesToken;
          }
          requestConfig.params = searchParams

          var promise =
            $http.get(config.url, requestConfig).then(function (response) {
              successCallback(response.data.Locations);
              return response.data.Locations;
            }, function (response) {
              console.log("Error");
              errorCallback(response);
              return response;
            });

          return {
            promise: promise,
            cancel: cancel
          };
        }

        function singleSearchQueryPromise(searchParams, successCallback, errorCallback) {
          var deferred = $q.defer();
          singleSearchQuery(searchParams, successCallback, errorCallback).promise
            .then((res) => deferred.resolve(res), (err) => deferred.reject(err));
          return deferred.promise;
        }

        function getValidPoiCategories() {
          if (lazyInitdValidPoiCategories === undefined) {
            let url = setRegion(config.url, $rootScope.userInfo.region);
            lazyInitdValidPoiCategories = $http.get(`${url}poiCategories`, {params: { authToken: `${config.authToken}` }})
            .then(({data}) => {
                return data.POICategories;
              }).catch(() => {
                return [];
              });
          }
          return lazyInitdValidPoiCategories;
        }
      }
    ]);
})(window.angular);




// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-single-search/singleSearch.service.js